module.exports = __webpack_public_path__ + "img/casino.29dc86be.png";